export default __webpack_public_path__ + "static/media/highlight-dark.a9e79ffc.png";